import styled from 'styled-components';

export const Dimensions = styled.div`
  pointer-events: none;

  position: absolute;
  bottom: -10px;
  padding: 2px 5px;
  transform: translateY(100%);

  border-radius: 5px;
  background-color: var(--panel-bg-color);
  color: var(--text-color);
  font-family: 'Inter';
  font-size: 12px;
  white-space: nowrap;
`;
